<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "AdminStatistics"
}
</script>

<style scoped>

</style>